<div class="checkbox-wrapper" (click)="changeValue()" (keydown.enter)="changeValue()" [class.disabled]="disabled">
  <div class="checkbox {{size}} {{color}}">
    <input *ngIf="formControl"
      [formControl]="formControl"
      [checked]="checked"
      [disabled]="disabled"
      [name]="'checkbox'+id"
      type="checkbox"
      class="checkbox-input {{notCheckedType}}"
      tabindex="0"/>
    <input *ngIf="!formControl"
      [value]="value"
      [checked]="checked"
      [disabled]="disabled"
      [name]="'checkbox'+id"
      type="checkbox"
      class="checkbox-input {{notCheckedType}}"
      tabindex="0"/>
    <div class="checkbox-check">
      <i class="fa-sharp fa-square-check"></i>
    </div>
    <div class="checkbox-square {{notCheckedType}}">
      <i *ngIf="notCheckedType === 'outlined' && !checked" class="fa-thin fa-square-check"></i>
    </div>
  </div>
  <span *ngIf="label && !labelTemplate" class="checkbox-label">
    {{ label | translate }}
  </span>
  <span *ngIf="labelTemplate" class="checkbox-label">
    <ng-content></ng-content>
  </span>
</div>
